import { render, staticRenderFns } from "./FrontPageHeroFullWidth.vue?vue&type=template&id=25a6f57e&"
import script from "./FrontPageHeroFullWidth.vue?vue&type=script&lang=js&"
export * from "./FrontPageHeroFullWidth.vue?vue&type=script&lang=js&"
import style0 from "./FrontPageHeroFullWidth.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports